import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShoppingBagVisitorQuery } from './getShoppingBagVisitor';

const useShoppingBagVisitorQuery = visitorId => {
  const experimentVariables = {
    configParamsInput: {
      offlineLookupOnly: false,
      params: [
        {
          name: 'eng.kufak.freestyle.credit_incentive.test_case_1',
          fallbackValue: 'Hidden',
          expectedValues: ['Hidden', 'Accessible'],
        },
        {
          name: 'eng.kufak.shopping.bag.secure_payment_copy',
          fallbackValue: 'hidden',
          expectedValues: ['hidden', 'enabled'],
        },
      ],
    },
  };

  const {
    data: shoppingBagVisitorData,
    loading: shoppingBagVisitorLoading,
    error: shoppingBagVisitorError,
  } = useGetShoppingBagVisitorQuery({
    skip: !visitorId,
    variables: {
      ...experimentVariables,
    },
    onCompleted: () => {
      recordMark('get_shopping_bag_visitor_graph_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('get_shopping_bag_visitor_graph_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(`GetShoppingBagVisitorQuery error: ${shoppingBagVisitorError}`, {
        error_message: shoppingBagVisitorError,
      });
    },
  });

  return {
    shoppingBagVisitorData,
    shoppingBagVisitorLoading,
    shoppingBagVisitorError,
  };
};

export default useShoppingBagVisitorQuery;
